import findIndex from 'lodash/findIndex'

export class BlockOrderCore<B extends string = string> {
  order: B[]
  constructor(order: B[]) {
    this.order = order
  }

  getPreBlockType(blockType: B) {
    return this.order?.[findIndex(this.order, value => value === blockType) - 1] ?? null
  }

  getNextBlockType(blockType: B) {
    return this.order?.[findIndex(this.order, value => value === blockType) + 1] ?? null
  }

  findBlockIndex(blockType: B) {
    return findIndex(this.order, value => value === blockType)
  }
}
